
// © 2001-2015 INOVx Solutions, Inc.
// 114 Pacifica Suite 300, Irvine, CA 92618 USA
// All rights reserved.
//
// This software is confidential, proprietary and unpublished property of
// INOVx Solutions, Inc.  It may NOT be copied in part or in whole on any
// medium, either electronic or printed, without the express written consent
// of INOVx Solutions, Inc.

import * as Interfaces from '../../Interfaces/Interfaces';
import * as Enumerations from '../../Enumerations/Enumerations';
class EventManager implements Interfaces.Interfaces.IEventManager {

    private _functionMap: { [eventType: string]: Function[]; } = {};
    private _registeredEvents: Enumerations.EventType[] = [];
    constructor() {
        this._registeredEvents = [];
    }

    dispose() {
        for (var i = 0; i < this._registeredEvents.length; i++) {
            this.unregisterEvent(this._registeredEvents[i]);
        }
    }

    registerEvent(eventType: Enumerations.EventType, callback: Function) {
        if (!this._registeredEvents[eventType]){
            this._registeredEvents.push(eventType);
        }

        var functionArray = this._functionMap[eventType.toString()];
        if (functionArray == null) {
            functionArray = [];
            this._functionMap[eventType.toString()] = functionArray;
        }

        functionArray.push(callback);
    }

    unregisterEvent(eventType: Enumerations.EventType) {
        var functions = this._functionMap[eventType.toString()];

        if (functions) {
            while (functions.length > 0) {
                functions.pop();
            }
        }
    }

    fireEvent(eventType: Enumerations.EventType, args: any) {
        var functions = this._functionMap[eventType.toString()];

        if (functions) {
            for (var i = 0; i < functions.length; i++) {
                if (functions[i]) {
                    functions[i](args);
                }
            }
        }
    }
}

export default EventManager;